import styled from 'styled-components';

export const PopoverContentWrapper = styled.div`
  max-width: 250px;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
`;

export const ExamSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const LabelWidgetWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
